module.exports = __webpack_public_path__ + "img/BETANDYOU.2899c167.svg";